import type {AppLocale} from 'i18n/locales'
import {
  AFFILIATE_PROMO_BLOGS_BG,
  AFFILIATE_PROMO_EMAILS_BG,
  AFFILIATE_PROMO_SOCIALS_BG,
} from './affiliatePromoKits.bg.generated'
import {
  AFFILIATE_PROMO_BLOGS_DE,
  AFFILIATE_PROMO_EMAILS_DE,
  AFFILIATE_PROMO_SOCIALS_DE,
} from './affiliatePromoKits.de.generated'
import {
  AFFILIATE_PROMO_BLOGS_EN,
  AFFILIATE_PROMO_EMAILS_EN,
  AFFILIATE_PROMO_SOCIALS_EN,
} from './affiliatePromoKits.en.generated'
import {
  AFFILIATE_PROMO_BLOGS_SV,
  AFFILIATE_PROMO_EMAILS_SV,
  AFFILIATE_PROMO_SOCIALS_SV,
} from './affiliatePromoKits.sv.generated'
import {
  AFFILIATE_PROMO_BLOGS_TR,
  AFFILIATE_PROMO_EMAILS_TR,
  AFFILIATE_PROMO_SOCIALS_TR,
} from './affiliatePromoKits.tr.generated'

const LINK_TOKEN = '{{AFF_LINK}}'

export type AffiliatePromoItem = {title: string; content: string}

function injectLink(
  items: AffiliatePromoItem[],
  link: string,
): AffiliatePromoItem[] {
  return items.map((x) => ({
    title: x.title,
    content: x.content.split(LINK_TOKEN).join(link),
  }))
}

function bundlesForLocale(locale: AppLocale): {
  emails: AffiliatePromoItem[]
  socials: AffiliatePromoItem[]
  blogs: AffiliatePromoItem[]
} {
  switch (locale) {
    case 'bg':
      return {
        emails: AFFILIATE_PROMO_EMAILS_BG,
        socials: AFFILIATE_PROMO_SOCIALS_BG,
        blogs: AFFILIATE_PROMO_BLOGS_BG,
      }
    case 'de':
      return {
        emails: AFFILIATE_PROMO_EMAILS_DE,
        socials: AFFILIATE_PROMO_SOCIALS_DE,
        blogs: AFFILIATE_PROMO_BLOGS_DE,
      }
    case 'sv':
      return {
        emails: AFFILIATE_PROMO_EMAILS_SV,
        socials: AFFILIATE_PROMO_SOCIALS_SV,
        blogs: AFFILIATE_PROMO_BLOGS_SV,
      }
    case 'tr':
      return {
        emails: AFFILIATE_PROMO_EMAILS_TR,
        socials: AFFILIATE_PROMO_SOCIALS_TR,
        blogs: AFFILIATE_PROMO_BLOGS_TR,
      }
    case 'en':
    default:
      return {
        emails: AFFILIATE_PROMO_EMAILS_EN,
        socials: AFFILIATE_PROMO_SOCIALS_EN,
        blogs: AFFILIATE_PROMO_BLOGS_EN,
      }
  }
}

export function getAffiliatePromoKits(
  locale: AppLocale,
  link: string,
): {
  emails: AffiliatePromoItem[]
  socials: AffiliatePromoItem[]
  blogs: AffiliatePromoItem[]
} {
  const {emails, socials, blogs} = bundlesForLocale(locale)
  return {
    emails: injectLink(emails, link),
    socials: injectLink(socials, link),
    blogs: injectLink(blogs, link),
  }
}
